/*
 * Copyright (C) 2017 Spanning Cloud Apps LLC.  All rights reserved.
 */
import './metadataComponents.tpl.html';

angular
  .module('metadataCompare.metadataComponents', ['shared.checkboxButton'])
  /**
   * Controller for the metadataComponents.tpl.html template.
   */
  .controller(
    'MetadataComponentsViewCtrl',
    function (
      $scope,
      $rootScope,
      $state,
      $stateParams,
      $filter,
      $q,
      httpMetadataRestore,
      httpQueue,
      progressFactory,
      ErrorService,
      WizardService,
      ALERT_EVENTS,
      METADATA_COMPARE_TYPES,
      METADATA_COMPARE_BATCH_TYPES,
      BATCH_RANGE,
      VIEW_STATES,
      orgInfo,
      metadataComponents
    ) {
      var i18n = $filter('i18n');

      // Register our page with the wizard service
      var page = WizardService.getCurrentPage();
      page.setHeaderText(i18n('SELECT_METADATA_COMPONENTS'));
      page.setStateParams($stateParams);
      page.setTouched(function () {
        return $scope.touched;
      });

      // Add a custom button to the wizard to handle Compare
      var compareButton = page.addCustomButton();
      compareButton.setTextKey('COMPARE');
      compareButton.setClick(compare);
      compareButton.setEnabled(function () {
        return $scope.selectedComponentTypes.length > 0;
      });

      // For the purposes of confirming cancellation of the wizard we'll consider the wizard touched if we get this far.
      // Once the operation is queued we'll reset this to avoid an exit confirmation after that point.
      $scope.touched = true;

      $scope.orderListByData = {
        alphaAsc: {
          order: 1,
          title: 'ALPHABETICALLY_ASC',
          expression: 'name',
          reverse: false,
          key: 'alphaAsc'
        },
        alphaDesc: {
          order: 2,
          title: 'ALPHABETICALLY_DESC',
          expression: 'name',
          reverse: true,
          key: 'alphaDesc'
        },
        countAsc: {
          order: 3,
          title: 'COUNT_ASC',
          expression: 'total',
          reverse: false,
          key: 'countAsc'
        },
        countDesc: {
          order: 4,
          title: 'COUNT_DESC',
          expression: 'total',
          reverse: true,
          key: 'countDesc'
        }
      };

      $scope.currentOrderBy = i18n($scope.orderListByData.countDesc.title);
      $scope.orderBy = $scope.orderListByData.countDesc.expression;
      $scope.reverse = $scope.orderListByData.countDesc.reverse;

      $scope.metadataComponents = metadataComponents;
      $scope.selectedComponentTypes = [];
      $scope.allCheckedMetadata = false;
      $scope.showRestorableOnly = false;
      // We'll lazy load these from the server
      $scope.restorableComponentTypes = null;

      $scope.typeQuery = {
        metadata: ''
      };

      /**
       * Handler for when a checkbox is toggled.
       * @param {string} typeName - The name of the type associated with the checkbox.
       */
      $scope.checkToggle = function (typeName) {
        var index = _.indexOf($scope.selectedComponentTypes, typeName);

        // add or remove the type from the selectedTypes array.
        if (index !== -1) {
          $scope.selectedComponentTypes.splice(index, 1);

          // if allCheckedMetadata is checked and we remove an item,
          // we want to uncheck all
          if ($scope.allCheckedMetadata) {
            $scope.allCheckedMetadata = false;
          }
        } else {
          $scope.selectedComponentTypes.push(typeName);

          // if allCheckedMetadata is unchecked and we add all items
          // we want to check all
          if (!$scope.allCheckedMetadata && $scope.selectedComponentTypes.length === $scope.metadataComponents.length) {
            $scope.allCheckedMetadata = true;
          }
        }
      };

      $scope.checkAllToggle = function () {
        $scope.allCheckedMetadata = !$scope.allCheckedMetadata;

        _.each($scope.metadataComponents, function (component) {
          var index = _.indexOf($scope.selectedComponentTypes, component.name);

          if ($scope.allCheckedMetadata && index === -1) {
            $scope.selectedComponentTypes.push(component.name);
          } else if (!$scope.allCheckedMetadata && index !== -1) {
            $scope.selectedComponentTypes.splice(index, 1);
          }
        });
      };

      /**
       * Utility to determine the current checked state of a checkbox.
       *
       * @param {string} typeName - The associated type.
       * @returns {boolean} True if checked, false if not checked.
       */
      $scope.isChecked = function (typeName) {
        return _.indexOf($scope.selectedComponentTypes, typeName) !== -1;
      };

      /**
       * Clear the typeQuery value if it exists.
       */
      $scope.clearQuery = function () {
        $scope.typeQuery.metadata = '';
      };

      /*
       * Determines if the typeQuery contains text for the current tab
       *
       * @returns {Boolean} - Flag if the current tab has type query text or not.
       */
      $scope.hasQueryText = function () {
        return $scope.typeQuery.metadata !== '';
      };

      /**
       * Order the batch details list. The orderBy and reverse variables are being used to sort list.
       * currentOrderBy is used for the current button title.
       *
       * @param {string} orderByKey - The key of object to get.
       */
      $scope.orderListBy = function (orderByKey) {
        var orderByObj = $scope.getOrderByObject(orderByKey);
        $scope.currentOrderBy = i18n(orderByObj.title);
        $scope.orderBy = orderByObj.expression;
        $scope.reverse = orderByObj.reverse;
      };

      /**
       * Get the order by object for given key.
       *
       * @param {string} key - The key of object to get.
       * @returns {Object} The order by option object.
       */
      $scope.getOrderByObject = function (key) {
        return $scope.orderListByData[key];
      };

      /**
       * Toggles the state of the 'Show only restorable metadata' checkbox.
       */
      $scope.toggleRestorableOnly = function () {
        var promise = $q.when();

        // If we're going to restrict to restorable types and we don't have the types loaded, load them now.
        if (!$scope.showRestorableOnly && !$scope.restorableComponentTypes) {
          $rootScope.showLoadingMask = true;

          promise = httpMetadataRestore
            .getRestorableComponentTypes()
            .then(function (types) {
              $scope.restorableComponentTypes = types;
            })
            .finally(function () {
              $rootScope.showLoadingMask = false;
            });
        }

        // Toggle the flag after we've loaded the types
        promise.then(function () {
          $scope.showRestorableOnly = !$scope.showRestorableOnly;
        });
      };

      /**
       * Determines whether a metadata component type should be displayed based on whether the 'Show only restorable
       * metadata' checkbox is checked.
       *
       * @param {string} componentType - The metadata component type to be checked
       * @returns {boolean} true if the component type should be displayed
       */
      $scope.isComparable = function (componentType) {
        var isComparable = true;
        if ($scope.showRestorableOnly) {
          isComparable = isRestorable(componentType);
        }
        return isComparable;
      };

      $scope.hasEnoughBackups = function () {
        return metadataComponents !== null;
      };

      $scope.submitBackup = function () {
        $rootScope.showLoadingMask = true;

        return httpQueue
          .submitBackup()
          .then(() => {
            progressFactory.backupInProgress = true;

            $scope.touched = false;
            $state.go(VIEW_STATES.ADMIN_HOME);
          })
          .catch((err) => {
            ErrorService.report(err, i18n('SUBMIT_BACKUP_FAILED'));
            progressFactory.backupInProgress = false;
          })
          .finally(() => {
            $rootScope.showLoadingMask = false;
          });
      };

      /**
       * Determines whether a metadata component type is restorable.
       *
       * @param {string} componentType - The metadata component type to be checked
       * @returns {boolean} true if the component type is restorable
       */
      function isRestorable(componentType) {
        return _.contains($scope.restorableComponentTypes, componentType);
      }

      /**
       * Handler for the Compare button. This is end of wizard and will send compare request.
       *
       * @returns {Promise} a promise that is resolved with one of the following:
       *   1) true if the wizard can be dismissed
       *   2) false if the wizard should remain
       *   3) an object containing the parameters to pass to the wizard cancel function to display an error message.
       */
      function compare() {
        var compareAgainst = parseInt($stateParams.compareAgainst),
          compareAgainstSameOrgBatch = parseInt($stateParams.compareAgainstSameOrgBatch),
          params = {
            leftSfOrgId: orgInfo.sfId,
            rightSfOrgId:
              compareAgainst === METADATA_COMPARE_TYPES.CROSS_ORG_COMPARE
                ? $stateParams.differentDestinationSfId
                : orgInfo.sfId,
            leftBatchId: parseInt($stateParams.batchPickerStoreLeftBatchId)
          };

        if (
          compareAgainst === METADATA_COMPARE_TYPES.SAME_ORG_COMPARE &&
          compareAgainstSameOrgBatch === METADATA_COMPARE_BATCH_TYPES.ANOTHER_BATCH
        ) {
          params.rightBatchId = parseInt($stateParams.batchPickerStoreRightBatchId);
        } else {
          params.rightBatchId = BATCH_RANGE.UNBOUNDED;
        }

        if ($scope.allCheckedMetadata) {
          params.components = $scope.showRestorableOnly ? $scope.restorableComponentTypes : 'ALL';
        } else {
          params.components = $scope.selectedComponentTypes;
        }

        $rootScope.showLoadingMask = true;

        return httpQueue
          .submitMetadataCompare(params)
          .then(function () {
            $rootScope.showLoadingMask = false;
            // Display the mask giving the user the option to wait.
            $rootScope.showMaskWithDashboardButton = true;
            // Reset the touched flag so the user can exit to the dashboard without another confirmation
            $scope.touched = false;
            return false; // Don't close the wizard
          })
          .catch(function () {
            $rootScope.$emit(ALERT_EVENTS.ERROR.eventName, i18n('METADATA_COMPARE_SUBMIT_FAILED'));
            $rootScope.showLoadingMask = false;
            $scope.touched = true; // We're back to needing confirmation to exit
            return false; // Don't close the wizard
          });
      }
    }
  );
